<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="3.16797" y="10.4492" width="31.6667" height="7.91667" rx="2" :fill="props.iconColor" />
		<path
			d="M6.33594 19H31.6693V31.25C31.6693 32.3546 30.7738 33.25 29.6693 33.25H8.33594C7.23137 33.25 6.33594 32.3546 6.33594 31.25V19Z"
			:fill="props.iconColor"
		/>
		<path d="M19 11.082V33.2487" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		<path
			d="M7.91797 6.70379C7.91797 4.75615 9.49684 3.16602 11.4445 3.16602H12.8723C16.2572 3.16602 19.0013 5.91008 19.0013 9.29505V9.29505C19.0013 9.40788 18.9098 9.49935 18.797 9.49935H10.7046C9.1656 9.49935 7.91797 8.24282 7.91797 6.70379V6.70379Z"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M30.0859 6.70379C30.0859 4.75615 28.5071 3.16602 26.5594 3.16602H25.1316C21.7467 3.16602 19.0026 5.91008 19.0026 9.29505V9.29505C19.0026 9.40788 19.0941 9.49935 19.2069 9.49935H27.2993C28.8383 9.49935 30.0859 8.24282 30.0859 6.70379V6.70379Z"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 38,
		height: 38,
		iconColor: '#818393',
	}
);
</script>

<style lang="scss" scoped></style>
